import { FC, useEffect, useState } from "react";
import { UserAddPopupProps } from "./types";
import { Column } from "../../../../../components/containers";
import styles from "../styles";
import { PopupClose } from "../../../../../popup";
import { TextInput } from "../../../../../components/inputs";
import {
  useAlertStore,
  usePopupStore,
  useThemeStore,
  useUserStore,
} from "../../../../../stores";
import AccessList from "../access-list";
import { Button } from "../../../../../components/buttons";
import { AccessList as AccessListType } from "../../types";
import { UserApi } from "../../../../../api";

const UserAddPopup: FC<UserAddPopupProps> = () => {
  const theme = useThemeStore((s) => s.theme);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);

  const [fullname, setFullname] = useState<string>("");
  const [role, setRole] = useState<string>("");
  const [access_list, setAccessList] = useState<AccessListType>([]);
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 430,
        background: theme.background,
        height: "100%",
        maxHeight: 605,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasUserAccess = useUserStore((s) => s.hasUserAccess);
  const pushAlert = useAlertStore((s) => s.pushAlert);

  const onSubmit = (): void => {
    if (!hasUserAccess(["Admin"])) return pushAlert("دسترسی غیر مجاز", "error");

    if (
      !fullname ||
      !role ||
      !username ||
      !password ||
      password !== confirmPassword
    )
      return pushAlert(
        "لطفا مطمئن شوید که فیلدها به درستی پر شده اند",
        "error"
      );

    setLoading(true);
    UserApi.addUser(
      fullname,
      role,
      username,
      password,
      confirmPassword,
      access_list
    )
      .then(() => {
        setPopupBody(null);
        pushAlert("عملیات موفقیت آمیز");
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Column style={styles.userPopupBase}>
      <PopupClose />
      <Column style={styles.userPopupContainer} gap={15}>
        <TextInput
          label="نام و نام خانوادگی"
          value={fullname}
          setValue={setFullname}
          background={theme.overlay}
        />
        <TextInput
          label="سمت"
          value={role}
          setValue={setRole}
          background={theme.overlay}
        />
        <AccessList
          style={{ width: "100%" }}
          accessList={access_list}
          updateAccessList={setAccessList}
        />
        <TextInput
          label="نام کاربری"
          value={username}
          setValue={setUsername}
          background={theme.overlay}
        />
        <TextInput
          label="رمز عبور"
          value={password}
          setValue={setPassword}
          background={theme.overlay}
          inputProps={{ type: "password" }}
        />
        <TextInput
          label="تایید رمز عبور"
          value={confirmPassword}
          setValue={setConfirmPassword}
          background={theme.overlay}
          inputProps={{ type: "password" }}
        />
        <Button
          onClick={onSubmit}
          background={theme.primary}
          color={theme.textOnprimary}
          loading={loading}
        >
          ثبت
        </Button>
      </Column>
    </Column>
  );
};

export default UserAddPopup;
